







































import {
	defineComponent,
	PropType,
	computed,
} from '@vue/composition-api';
import SimpleCard from '@front-app/components/cards/SimpleCard.vue';
import { GroupsLogoStore } from '@front-app/store/singletons/Groups';
import { htmlToText } from '@front-app/util/content';
import { PublicGroup } from '@front-app/services/GroupsApi/GroupModel';
import { STATUS } from '@front-app/constants/state';

export default defineComponent({
	components: {
		SimpleCard,
	},
	props: {
		group: {
			type: Object as PropType<PublicGroup>,
			required: true,
		},
	},
	setup(props, ctx) {
		const logo = computed(() => GroupsLogoStore.get(props.group.groupId));
		const categories = computed(() => props.group.categories
			.concat(props.group.categories.map((category) => ctx.root.$t(category)) as string[])
			.join(', '));

		return {
			categories,
			logo,
			isLoading: computed(() => logo.value.status === STATUS.LOADING),
			// Util
			htmlToText,
		};
	},
});
